<template>
  <div class="container article">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>笔记</el-breadcrumb-item>
        <el-breadcrumb-item>笔记管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">笔记管理</h2>
        </div>
        <el-button class="button"
                   type="primary"
                   @click="creatNote()">新建笔记</el-button>
        <el-button class="button"
                   type="primary"
                   @click="creatOption()">看法</el-button>
        <el-button class="button"
                   type="primary"
                   @click="creatComment()">评论</el-button>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="发布人"
                      prop="name">
          <el-input v-model="query.author_user_keyword"
                    placeholder="输入发布人的姓名/昵称/手机号"
                    style="width: 200px"
                    @input="fetchArticleList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="发布人身份"
                      prop="status">
          <el-select v-model="author_user_educate_types"
                     placeholder="请选择"
                     clearable
                     @change="fetchArticleList(true)"
                     style="width:100px;">
            <el-option v-for="item in filter.educate_types"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="笔记标题"
                      prop="name">
          <el-input v-model="query.title_keyword"
                    placeholder="请输入笔记标题"
                    style="width: 200px"
                    @input="fetchArticleList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="笔记分类"
                      prop="status">
          <el-select v-model="query.note_types"
                     placeholder="请选择"
                     clearable
                     @change="fetchArticleList(true)"
                     style="width:100px;">
            <el-option v-for="item in filter.types"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="关联科目"
                      prop="name">
          <el-input v-model="query.topic_cms_keyword"
                    placeholder="请输入标题关键字"
                    style="width: 200px"
                    @input="fetchArticleList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="关联商品"
                      prop="name">
          <el-input v-model="query.bring_product_keyword"
                    placeholder="请输入标题关键字"
                    style="width: 200px"
                    @input="fetchArticleList(true)"
                    clearable></el-input>
        </el-form-item>

        <el-form-item label="是否付费"
                      prop="status">
          <el-select v-model="query.receive_fee_statuses"
                     placeholder="请选择"
                     clearable
                     @change="fetchArticleList(true)"
                     style="width:100px;">
            <el-option v-for="item in filter.fee"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="发布日期">
          <el-date-picker class="datetime"
                          v-model="createDatetime"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          clearable
                          @change="timechange"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>

      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">笔记列表</h3>
        <el-form :inline="true"
                 label-width="70px"
                 size="small">
          <el-form-item>
            <el-radio-group v-model="query.statuses"
                            @change="fetchArticleList(true)">
              <el-radio-button v-for="(item, index) in filter.type"
                               :key="index"
                               :label="item.value">
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="values">
        <el-table :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           width="80"
                           label="ID"
                           align="center">
          </el-table-column>
          <el-table-column label="发布人"
                           width="200"
                           align="center"
                           v-if="query.is_author == 1"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-link v-if="scope.row.author_user_obj"
                       type="primary"
                       @click="handleLookUser(scope.row.author_user_obj.id)">{{ scope.row.author_user_obj.nickname }}</el-link>
              <span v-if="scope.row.author_user_virtual_type==1"
                    class="virBtn">虚拟</span>

            </template>
          </el-table-column>

          <el-table-column prop="title"
                           width="90"
                           label="发布人身份"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag type="success"
                      v-if="scope.row.author_user_obj.senior_id">学长</el-tag>
              <el-tag v-else>学员</el-tag>

            </template>
          </el-table-column>
          <el-table-column prop="title"
                           width="400"
                           label="笔记标题"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="item-table-column">
                {{ scope.row.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           label="笔记分类"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formateCategory_id(scope.row.note_type) }}
            </template>
          </el-table-column>

          <el-table-column prop="pv"
                           label="浏览量"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.total_browse_count }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="pv"
                           label="点赞量"
                           align="center">
            <template slot-scope="scope">
              <span style="color:#409EFF; cursor: pointer;"
                    @click="handleClick(scope.row)">{{ scope.row.total_like_count }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="comment_extend_comment_count"
                           label="评论数"
                           align="center">
            <template slot-scope="scope">
              <span style="font-size: 14px; color: #409eff;  cursor: pointer;"
                    @click="handleComment(scope.row)">{{scope.row.total_comment_count ? scope.row.total_comment_count : 0}}条</span>
            </template>
          </el-table-column>
          <el-table-column prop="topic_college_code"
                           label="关联科目"
                           width="250"
                           show-overflow-tooltip
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.topic_college_code">({{scope.row.topic_college_code  }}){{scope.row.topic_college_name }}</span>
              <span v-if="scope.row.topic_major_code">({{scope.row.topic_major_code }}){{scope.row.topic_major_name }}</span>
              <span v-if="scope.row.topic_subject_code">({{scope.row.topic_subject_code }}){{scope.row.topic_subject_name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="comment_extend_comment_count"
                           label="关联商品"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.bring_product_list.length>0">查看商品</span>
              <span v-else> -</span>
            </template>
          </el-table-column>
          <el-table-column prop="receive_fee_status"
                           label="是否付费"
                           align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.receive_fee_status == 0?'warning':''">{{scope.row.receive_fee_status == 0 ? '不收费' : '收费'}}</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="发布日期"
                           align="center"
                           width="100"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.publish_time
                  ? $moment(scope.row.publish_time).format("YYYY-MM-DD")
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column label="更新日期"
                           align="center"
                           width="100">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.update_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>

          <el-table-column label="状态"
                           align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status=='0'"
                      type="warning">
                待审核
              </el-tag>
              <el-tag v-if="scope.row.status=='2'"
                      type="success">
                已审核
              </el-tag>
              <el-tag v-if="scope.row.status=='3'"
                      type="danger">
                未通过
              </el-tag>
              <el-tag v-if="scope.row.status=='4'"
                      type="info">
                已删除
              </el-tag>

            </template>
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           width="160"
                           fixed="right"
                           v-if="isfixed">
            <template slot-scope="scope">
              <div style="zIndex:99"> <el-link type="primary"
                         :underline="false"
                         @click="goDetail(scope.row)">编辑</el-link>
                <el-link v-if="scope.row.status==0||scope.row.status==3"
                         type="warning"
                         :underline="false"
                         @click="goAudit(scope.row,1)">审核</el-link>
                <el-link v-if="scope.row.status==2"
                         type="primary"
                         :underline="false"
                         @click="goLook(scope.row)">查看</el-link>
                <el-link v-if="scope.row.status==2"
                         type="danger"
                         :underline="false"
                         @click="goAudit(scope.row,2)">下线</el-link>
              </div>

              <!-- <el-link type="primary"
                       :underline="false"
                       @click="handleToPreview(scope.row)">浏览</el-link>
              <el-link type="danger"
                       @click="handleArticleRemove(scope.row.id)"
                       :underline="false">删除</el-link> -->
            </template>
          </el-table-column>
          <el-table-column label=""
                           width="40"
                           align="center"
                           fixed="right"
                           v-else>
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link"> ... </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a"
                                    style="margin-bottom: 6px"><span @click="goDetail(scope.row)"
                          style="font-size: 16px; color: #409eff">
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item command="b"
                                    style="margin-bottom: 6px"><span @click="handleToPreview(scope.row)"
                          style="font-size: 16px; color: #409eff">
                      浏览
                    </span></el-dropdown-item>
                  <el-dropdown-item command="c"
                                    style="margin-bottom: 6px"><span @click="handleToClone(scope.row.id)"
                          style="font-size: 16px; color: #409eff">
                      复制
                    </span></el-dropdown-item>
                  <el-dropdown-item command="d"
                                    style="margin-bottom: 6px"><span @click="handleArticleRemove(scope.row.id)"
                          style="font-size: 16px; color: #f56c6c">
                      删除
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <ChangeTagsReal @close="editDialog = false"
                    :visible="editDialog"
                    @submit="fetchArticleList()"
                    :content="editContent" />
    <el-dialog title="评论列表"
               :visible.sync="commentShow"
               width="50%">
      <el-table :data="commentResult"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                :default-expand-all="false"
                @expand-change="handleExpand"
                :tree-props="{children: 'children'}">
        <el-table-column prop="id"
                         label="ID"
                         align="center"
                         width="90">
        </el-table-column>
        <el-table-column label="发布人"
                         width="170"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.create_user_obj.nickname }}/{{scope.row.create_user_obj.mobile}}</span></template>
        </el-table-column>
        <el-table-column label="评论内容"
                         width="200"
                         align="left"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.content }}</span></template>
        </el-table-column>
        <el-table-column label="评论对象"
                         width="170"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.replyed_user_obj">{{ scope.row.replyed_user_obj.nickname }}/{{scope.row.replyed_user_obj.mobile}}</span>
            <span v-else>经验</span>
          </template>
        </el-table-column>
        <el-table-column label="点赞数"
                         width="80"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.like_count }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间"
                         align="center"
                         width="200"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{
                scope.row.create_time
                  ? $moment(scope.row.create_time).format("YYYY-MM-DD")
                  : ""
              }}
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         align="center"
                         width="100"
                         fixed="right">
          <template slot-scope="scope">
            <el-link type="primary"
                     :underline="false"
                     @click="commentDetle(scope.row)"><span class="cao">删除</span></el-link>
          </template>
        </el-table-column>

      </el-table>
      <div style="display:flex;justify-content:center; ">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(commentQuery.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(commentQuery.pageSize)"
                       :total="Number(commentTotal)"
                       @size-change="handleSizeComment"
                       @current-change="handlePageComment">
        </el-pagination>

      </div>

    </el-dialog>

    <el-dialog title="笔记审核"
               :visible.sync="auditShow"
               width="900px"
               top="10px"
               @close="handleClose()">
      <div class="auditContent">
        <div class="iframContent">
          <iframe :src="currentSrc"
                  width="300px"
                  frameborder="1"
                  style=" border: 1px solid black;"
                  height="600px"
                  @load="handleIframeLoad"></iframe>
        </div>

        <div class="formRight">
          <!-- v-if="auditRadio == 2" -->
          <el-form :model="form"
                   :rules="rules"
                   ref="formRules"
                   label-width="80px"
                   style="margin-top:20px">
            <el-form-item label="审核结果"
                          prop="auditRadio">
              <el-radio-group v-model="form.auditRadio"
                              @change="changeAudit">
                <el-radio :label="1">通过</el-radio>
                <el-radio :label="2">驳回</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="驳回理由"
                          v-if="form.auditRadio==2"
                          prop="rejection">
              <el-input type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        v-model="form.rejection">
              </el-input>
            </el-form-item>
            <el-form-item label="关联积分"
                          prop="check_send_point">
              <div class="sendPoint">
                <div class="pointItem"
                     v-for="(item,index) in filter.points"
                     :key="index"
                     :class="{'point-other':currentIndex==index}"
                     @click="handlePoint(index,item)">{{item.label}}</div>
              </div>
            </el-form-item>
            <el-form-item label="选择基础点赞量区间"
                          label-width="86px"
                          v-if="form.auditRadio==1">
              <div class="rangeContent">
                <div v-for="(item,index) in NumRanges"
                     :key="index"
                     class="rangeItem"
                     :class="{'active':item.flag}"
                     @click="handleLike(item)">{{item.label}}

                  <img src="https://upload.kaoyanbox.net/0474a5bcc4fed067ae81ab68267e6c68.png"
                       class="checkImg"
                       v-if="item.flag" />

                </div>
              </div>
            </el-form-item>

          </el-form>

        </div>
      </div>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="auditShow = false">取 消</el-button>
        <el-button type="primary"
                   @click="auditSubmit('formRules')">确 定</el-button>
        <el-button type="primary"
                   @click="handleToNext('formRules')">确定并继续</el-button>
      </span>
    </el-dialog>
    <SycNote :isVisible="noteVisible"
             @close="noteClose"
             :title="title" />
    <EditNote :isVisible="editVisible"
              :rowId="rowId"
              @Editclose="EditClose" />
    <Createcoment :isVisible="commentDialog"
                  @close="commentClose()"
                  :detailId="detailId" />
    <LookUpvote :isVisible="upvoteVisible"
                @close="upvoteClose()"
                :authorId="authorId"
                :detailId="detailId"
                :total_like_count="total_like_count"
                :type="types" />
    <Option :isVisible="optionDialog"
            @close="optionClose()" />
    <UserDetail :visible="seniorVisible"
                :rowId="rowId"
                @close="seniorClose()" />
  </div>
</template>

<script>
import SycNote from '@/components/dialog/syncNote'
import EditNote from '@/components/dialog/editNote/index'
import ArticleCard from '@/components/card/Article'
import ChangeTagsReal from '@/components/dialog/article/ChangeTagsReal'
import Createcoment from '@/components/dialog/createComment'
import LookUpvote from '@/components/dialog/lookUpvote'
import Option from '@/components/dialog/options/index'
import {
  articleDestroy,
  articleCategoryList,
  articleClone,
} from '@/api/article'
import UserDetail from '@/components/dialog/senior/userDetail'
import {
  noteList,
  noteAuite,
  noteDelete,
  noteOneList,
  noteTwoList,
  noteCommentDelete,
  notePut,
} from '@/api/senior'

export default {
  components: {
    ArticleCard,
    UserDetail,
    EditNote,
    ChangeTagsReal,
    SycNote,
    Createcoment,
    LookUpvote,
    Option,
  },
  data() {
    return {
      author_user_educate_types: '',
      inActive: 1,
      commentDialog: false,
      upvoteVisible: false,
      optionDialog: false,
      title: '新建笔记',
      rules: {
        auditRadio: [
          { required: true, message: '请选择审核结果', trigger: 'change' },
        ],
        rejection: [
          { required: true, message: '请填写拒绝理由', trigger: 'blur' },
        ],
        check_send_point: [],
      },
      NumRanges: [
        { id: 1, label: '0-10个', minHours: 0, maxHours: 10, flag: true },
        { id: 2, label: '11-30个', minHours: 11, maxHours: 30, flag: false },
        { id: 3, label: '31-60个', minHours: 31, maxHours: 60, flag: false },
        { id: 4, label: '61-100个', minHours: 61, maxHours: 100, flag: false },
        {
          id: 5,
          label: '101-200个',
          minHours: 101,
          maxHours: 200,
          flag: false,
        },
        {
          id: 6,
          label: '201-500个',
          minHours: 201,
          maxHours: 500,
          flag: false,
        },
      ],
      currentSrc: '',
      id: '',
      auditRadio: 1,
      auditShow: false,
      commentShow: false,
      rejection: '',
      createDialog: false,
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        statuses: 0,
        is_author: 1,
      },
      commentQuery: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
      },
      createDatetime: '',
      pageTotal: 10,
      commentTotal: 10,
      filter: {
        type: [
          { label: '待审核', value: '0' },
          { label: '已审核', value: '2' },
          { label: '未通过', value: '3' },
        ],
        status: [
          { label: '全部', value: '' },
          { label: '上架', value: '1' },
          { label: '下架', value: '0' },
        ],
        educate_types: [
          { label: '学生', value: '0' },
          { label: '学长', value: '1' },
          { label: '虚拟学生', value: '2' },
          { label: '虚拟学长', value: '3' },
        ],
        types: [
          { label: '求解答', value: '1' },
          { label: '求资料', value: '2' },
          { label: '求录课', value: '3' },
          { label: '经验', value: '4' },
          { label: '看法', value: '5' },
          { label: '资料', value: '6' },
          { label: '录播课', value: '7' },
          { label: '答疑课', value: '8' },
          { label: '1v1辅导', value: '9' },
          { label: '求学长1v1', value: '10' },
          { label: '考研分享', value: '11' },
        ],
        fee: [
          { label: '否', value: '0' },
          { label: '是', value: '1' },
        ],
        points: [
          { label: '-10分', value: '-10' },
          { label: '0分', value: '0' },
          { label: '20分', value: '20' },
          { label: '30分', value: '30' },
          { label: '40分', value: '40' },
          { label: '50分', value: '50' },
        ],
      },
      categorys: [],
      results: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
      tabName: '',
      editContent: {},
      editDialog: false,
      commentResult: [],
      clickRow: {},
      twoId: {},
      form: { auditRadio: 1, rejection: '' },
      currentIndex: 2,
      currentItem: {},
      noteVisible: false,
      editVisible: false,
      detailId: null,
      total_like_count: 0,
      authorId: null,
      selectedRange: null,
      rangeNum: 0,
      types: '笔记',
      rowId: null,
      seniorVisible: false,
      currentRow: {},
      currentRowIndex: 0,
      nocheckList: [],
    }
  },
  created() {
    this.parseQuery()
    this.fetchCategoryList()
    this.fetchArticleList()
    this.$store.dispatch('getAllColleges')
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.start_publish_time = this.$moment(value[0]).valueOf()
        this.query.end_publish_time = this.$moment(value[1]).valueOf()
      } else {
        this.query.start_publish_time = ''
        this.query.end_publish_time = ''
      }
    },
  },
  methods: {
    creatComment() {
      this.$router.push('/senior/randomComment')
    },
    handleLookUser(id) {
      this.rowId = id
      this.seniorVisible = true
    },
    seniorClose() {
      this.seniorVisible = false
    },
    changeAudit(e) {
      if (e == 2) {
        this.currentIndex = 1
      } else if (e == 1) {
        this.currentIndex = 2
      }
    },
    handleClick(row) {
      this.detailId = row.id
      this.authorId = row.author_user_obj.id
      this.total_like_count = row.total_like_count
      this.upvoteVisible = true
    },
    handleLike(range) {
      range.flag = !range.flag
      if (range.flag) {
        this.NumRanges.map((item) => {
          if (item.id != range.id) {
            item.flag = false
          }
        })
      }
    },
    upvoteClose() {
      this.upvoteVisible = false
      this.fetchArticleList(true)
    },
    optionClose() {
      this.optionDialog = false
    },
    goLook(row) {
      this.detailId = row.id
      this.commentDialog = true
    },
    creatNote() {
      this.noteVisible = true
    },
    creatOption() {
      this.optionDialog = true
    },
    noteClose() {
      this.noteVisible = false
      this.fetchArticleList()
    },
    EditClose() {
      this.editVisible = false
      this.fetchArticleList()
    },
    commentClose() {
      this.commentDialog = false
      this.fetchArticleList()
    },
    handlePoint(index, item) {
      console.log('关联积分', index, item)
      this.currentIndex = index
      this.currentItem = item
    },
    handleClose() {
      this.auditShow = false
      this.currentSrc = ''
      this.form.rejection = ''
      this.form.auditRadio = 1
      this.currentIndex = 2

      this.NumRanges = [
        { id: 1, label: '0-10个', minHours: 0, maxHours: 10, flag: true },
        { id: 2, label: '11-30个', minHours: 11, maxHours: 30, flag: false },
        { id: 3, label: '31-60个', minHours: 31, maxHours: 60, flag: false },
        { id: 4, label: '61-100个', minHours: 61, maxHours: 100, flag: false },
        {
          id: 5,
          label: '101-200个',
          minHours: 101,
          maxHours: 200,
          flag: false,
        },
        {
          id: 6,
          label: '201-500个',
          minHours: 201,
          maxHours: 500,
          flag: false,
        },
      ]
    },
    handleIframeLoad() {},
    timechange(e) {
      if (e == null) {
        this.query.start_publish_time = ''
        this.query.end_publish_time = ''
      }
      this.fetchArticleList(true)
    },
    handleExpand(val) {
      this.twoId = val
      this.twoComment()
    },
    //获取一级二级评论
    handleComment(row) {
      this.commentShow = true
      this.clickRow = row
      this.oneComment()
    },
    oneComment() {
      let data = {
        pageSize: this.commentQuery.pageSize,
        pageIndex: this.commentQuery.pageIndex,
        note_id: this.clickRow.id,
      }
      noteOneList(data).then((res) => {
        res.list.map((item) => {
          item.children = []
          if (item.level_one_first_row) {
            item.children.push(item.level_one_first_row)
          }
        })
        this.commentTotal = res.count
        this.commentResult = res.list.sort(
          (a, b) => b.create_time - a.create_time
        )
      })
    },
    //获取二级评论列表
    twoComment() {
      let data = {
        isPaging: 0,
        parent_level_one_id: this.twoId.id,
      }
      noteTwoList(data).then((res) => {
        this.commentResult.map((v) => {
          if (v.id == res.list[0].parent_level_one_id) {
            v.children = res.list.sort((a, b) => b.create_time - a.create_time)
          }
        })
      })
    },
    commentDetle(row) {
      this.$confirm('确定要删除当前评论吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let ids = []
        ids.push(row.id)
        noteCommentDelete({
          ids: ids,
        }).then((res) => {
          this.$message.success('删除成功')
          this.oneComment()
          this.fetchArticleList()
        })
      })
    },
    //回显数据
    updateEcho() {
      if (location.host.includes('admin.kaoyanbox.com')) {
        this.currentSrc = `https://senior.kaoyanbox.com/#/graduatA/experienceDatail/index?id=${this.nocheckList[0].id}`
      } else {
        this.currentSrc = `https://test-senior.kaoyanbox.net/#/graduatA/experienceDatail/index?id=${this.nocheckList[0].id}`
      }

      this.id = this.nocheckList[0].id
      this.authorId = this.nocheckList[0].author_user_obj.id
    },
    goAudit(row, flag) {
      if (flag == 1) {
        // 刚打开审核
        this.nocheckList = this.results
        this.currentRow = row
        setTimeout(() => {
          this.currentRowIndex = this.nocheckList
            .map((item) => item.id)
            .indexOf(this.currentRow.id)

          this.nocheckList.splice(this.currentRowIndex, 1)
          this.nocheckList.unshift(this.currentRow)
        }, 500)
        this.updateEcho()
      } else {
        if (location.host.includes('admin.kaoyanbox.com')) {
          this.currentSrc = `https://senior.kaoyanbox.com/#/graduatA/experienceDatail/index?id=${row.id}`
        } else {
          this.currentSrc = `https://test-senior.kaoyanbox.net/#/graduatA/experienceDatail/index?id=${row.id}`
        }

        this.id = row.id
        this.authorId = row.author_user_obj.id
        if (flag == 2) {
          this.form.auditRadio = 2
          this.currentIndex = 1
        }
      }

      this.auditShow = true
    },
    auditSubmit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          let hasOutOfStock = this.NumRanges.some(function (product) {
            return product.flag == true // 检查是否有库存为 0 的商品
          })
          if (hasOutOfStock) {
            let checkItem = null
            this.NumRanges.map((item) => {
              if (item.flag) {
                checkItem = item
              }
            })
            this.selectedRange = checkItem
            const { minHours, maxHours, label } = checkItem
            this.rangeNum =
              Math.floor(Math.random() * (maxHours - minHours + 1)) + minHours
            notePut({
              uid: this.authorId,
              id: this.id,
              base_like_count: this.rangeNum,
            }).then((res) => {})
          }

          if (this.form.auditRadio == 1) {
            noteAuite({
              rows: [
                {
                  note_id: this.id,
                  check_status: 1,
                  check_send_point:
                    this.filter.points[this.currentIndex].value * 1,
                },
              ],
            }).then((res) => {
              if (!res) {
                this.$message.success('操作成功!')

                this.fetchArticleList()
                this.handleClose()
              }
            })
          } else if (this.form.auditRadio == 2) {
            noteAuite({
              rows: [
                {
                  note_id: this.id,
                  check_status: 2,
                  check_refuse_reason: this.form.rejection,
                  check_send_point:
                    this.filter.points[this.currentIndex].value * 1,
                },
              ],
            }).then((res) => {
              if (!res) {
                this.fetchArticleList()
                this.handleClose()
                this.$message.success('操作成功!')
              }
            })
          }
        }
      })
    },
    //通过并继续
    handleToNext(rules) {
      if (this.nocheckList.length == 1) {
        this.auditSubmit(rules, 1)

        this.$message.success(`暂时待审核没有数据了`)
        return
      } else {
        this.auditSubmit(rules, 1)
        this.$message.success(`审核通过请继续下一条`)
        this.nocheckList.splice(0, 1)
        // this.goAudit(this.nocheckList[0])
        setTimeout(() => {
          this.auditShow = true
          this.updateEcho()
        }, 300)
      }
    },

    // 文章列表请求
    fetchArticleList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }

      this.query.is_author = 1
      if (this.author_user_educate_types == '2') {
        this.query.author_user_educate_types = '0'
        this.query.author_user_virtual_type = '1'
      } else if (this.author_user_educate_types == '3') {
        this.query.author_user_educate_types = '1'
        this.query.author_user_virtual_type = '1'
      } else {
        if (this.author_user_educate_types != '') {
          this.query.author_user_virtual_type = '0'
          this.query.author_user_educate_types = this.author_user_educate_types
        } else {
          this.query.author_user_virtual_type = ''
          this.query.author_user_educate_types = ''
        }
      }
      noteList(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分类列表请求
    fetchCategoryList() {
      articleCategoryList({ isPaging: 0 }).then((res) => {
        this.categorys = res.list
      })
    },
    // 检索条件变化
    handleFilterChange(value, type) {
      if (type === 'sort') {
        this.query.sort = value
      }
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchArticleList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchArticleList()
    },
    handleSizeComment(val) {
      this.$set(this.commentQuery, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.oneComment()
    },
    handlePageComment(val) {
      this.$set(this.commentQuery, 'pageIndex', val)
      this.oneComment()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchArticleList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      // 手动处理
      this.createDatetime = null
      setTimeout(() => {
        this.fetchArticleList()
      }, 20)
    },
    // 分类管理
    // handleToCategory() {
    //   this.$router.push(`/article/category`)
    // },
    // 文章创建
    // handleArticelCreate() {
    //   this.$router.push(`/article/create`)
    // },
    // 文章删除
    handleArticleRemove(materialId) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          articleDestroy({ id: materialId }).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchArticleList()
          })
        })
        .catch(() => {})
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.startTime && this.query.endTime) {
        this.createDatetime = [
          this.$moment(Number(this.query.startTime)),
          this.$moment(Number(this.query.endTime)),
        ]
      }
      if (this.query.sort_type) {
        this.query.sort_type = Number(this.query.sort_type)
      }
      //   this.tabName = this.query.is_author == 1 ? "senior" : "all"
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    formateCategory_id(type) {
      if (type == 1) {
        return '求解答'
      } else if (type == 2) {
        return '求资料'
      } else if (type == 3) {
        return '求录课'
      } else if (type == 4) {
        return '经验'
      } else if (type == 5) {
        return '看法'
      } else if (type == 6) {
        return '资料'
      } else if (type == 7) {
        return '录播课'
      } else if (type == 8) {
        return '答疑卡'
      } else if (type == 9) {
        return '1v1辅导'
      } else if (type == 10) {
        return '求学长1v1'
      } else if (type == 11) {
        return '考研分享'
      }
    },
    // 表格操作跳转页面
    goDetail(item) {
      this.editVisible = true
      this.rowId = item.id
    },
    // 预览
    handleToPreview(item) {
      if (item) {
        if (location.host.includes('admin.kaoyanbox.com')) {
          window.open(
            `https://senior.kaoyanbox.com/#/graduatA/experienceDatail/index/?id=${item.id}`
          )
        } else {
          window.open(
            `https://test-senior.kaoyanbox.net/#/graduatA/experienceDatail/index/?id=${item.id}`
          )
        }
      }
    },
    handleToClone(id) {
      // 二次确认
      this.$confirm('确定要复制吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          articleClone({ id: id }).then((res) => {
            this.$message.success(`复制成功，请在下架列表中查看`)
            this.fetchArticleList()
          })
        })
        .catch(() => {})
    },
    handleTabChange(tab) {
      if (tab.name == 'senior') {
        this.query.is_author = 1
      } else {
        this.query.is_author = 0
      }
      this.fetchArticleList(true)
    },
    changeTags_real(row) {
      this.editContent = Object.assign({}, row)
      this.editDialog = true
    },
    handleToOrigin(row) {
      if (row.origin_url) {
        window.open(row.origin_url)
      } else {
        this.$message.error('暂无原文链接')
      }
    },
  },
}
</script>

<style scoped lang="less">
::v-deep .el-dialog__header {
  background: #ecf2fe;
}
::v-deep .el-table__fixed-right {
  background: #fff;
  z-index: 99 !important; /* 数值需高于滚动内容的z-index */
}
/* 确保操作栏背景不透明 */
.el-table__fixed-right .el-table__cell {
  background-color: #fff; /* 或其他背景色 */
  opacity: 1;
}
.article {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 101%;
    height: 40px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }

    .filter-item {
      display: flex;

      .label {
        line-height: 32px;
        margin-right: 10px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409eff;
        }
      }
    }
  }
  .results {
    margin-top: 10px;
    padding-right: 32px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }
    .material-item {
      margin-right: 15px;
      margin-bottom: 15px;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
    .el-link {
      margin: 0 8px;
    }
    .item-table-column {
      text-align: left;
    }
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
}
.virBtn {
  display: inline-block;
  text-align: 34px;
  width: 34px;
  font-size: 10px;
  height: 22px;
  line-height: 22px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #cccccc;
}
.tag-wrap {
  text-align: left;
  width: 100%;
  min-height: 30px;
}
.el-tag {
  margin: 0px 5px;
}
.auditContent {
  width: 850px;
  display: flex;
  justify-content: space-between;
  padding-left: 32px;
  .iframContent {
  }
  .formRight {
    .sendPoint {
      display: flex;
      .pointItem {
        margin-right: 10px;
        text-align: center;
        width: 58px;
        height: 28px;
        font-size: 12px;
        line-height: 28px;
        background: #feffff;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #dcdcdc;
      }
      .point-other {
        font-size: 12px;
        border: none;
        color: #0052d9;
        background: url('https://upload.kaoyanbox.net/8bedfc7f6fb70fe51ea4a04d776b5416.png')
          no-repeat;
        background-size: 100% 100%;
      }
    }
    .rangeContent {
      width: 400px;
      display: flex;
      flex-flow: wrap;

      .rangeItem {
        cursor: pointer;
        margin-bottom: 16px;
        margin-right: 20px;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #dcdcdc;
        padding: 0px 4px;
        position: relative;
        .checkImg {
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: 14.16px;
          height: 12.5px;
        }
      }
      .active {
        border: 1px solid #1f86fe;
      }
    }
  }
}
</style>
